<template>
  <div class="group-modal-wrapper">
    <div class="group-modal">
      <form>
        <!-- NAME -->
        <label for="groupModalName" class="input-label">Име на бригада</label>
        <div class="input-wrapper" :class="{ invalid: !isNameValid }">
          <span class="mck2">5</span>
          <input
            id="groupModalName"
            type="text"
            placeholder="Име на бригада"
            v-model="group.name"
            @keyup="isNameValid = true"
            @keydown.enter.prevent
          />
        </div>

        <!-- REPORTERS -->
        <label for="reportersInput" class="input-label"
          >Отчетници с право да самоотчитат бригадата</label
        >
        <div class="input-wrapper">
          <span class="mck2">5</span>
          <input
            @click="isAddUsersModalOpened = true"
            id="reportersInput"
            type="text"
            readonly="true"
            placeholder="Изберете един или повече отчетници"
            :value="grouReporters"
          />
        </div>

        <template v-if="users.length">
          <label for="groupModalUsers" class="input-label"
            >Работници в групата:</label
          >
          <div class="users-list">
            <span class="mck2">5</span>
            <p v-for="u in users" :key="u._id">{{ u.name }}</p>
          </div>
        </template>
        <div class="group-modal-actions">
          <div class="switch-container">
            <label class="switch">
              <input type="checkbox" v-model="group.isActive" />
              <span class="slider"></span>
            </label>
            <label v-if="group.isActive">Активен</label>
            <label v-else>Неактивен</label>
          </div>
          <div class="btns">
            <button class="btn btn-close" @click.prevent="closeModal(false)">
              <span class="mck">F</span>
              Отказ
            </button>
            <button
              v-if="!id"
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="create"
            >
              <span class="mck">B</span>
              Създай
            </button>
            <button
              v-else
              class="btn btn-new"
              type="submit"
              value="Submit"
              @click.prevent="edit"
            >
              <span class="mck">B</span>
              Редактирай
            </button>
          </div>
        </div>
      </form>
    </div>

    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :incomingUsers="group.reporters"
        :usersType="'reporters'"
        @saveAddUsersModal="saveAddUsersModal"
        @close="isAddUsersModalOpened = false"
      />
    </transition>
  </div>
</template>

<script>
import log from "../mixins/log.js";
import AddUsersModal from "./AddUsersModal.vue";
export default {
  mixins: [log],
  props: ["id"],
  components: { AddUsersModal },
  computed: {
    grouReporters() {
      return this.group.reporters ? this.group.reporters.map((r) => r.name) : [];
    },
  },
  data() {
    return {
      isNameValid: true,
      isAddUsersModalOpened: false,
      group: {
        name: "",
        isActive: true,
        reporters: [],
      },
      users: [],
    };
  },
  methods: {
    saveAddUsersModal(reporters) {
      this.group.reporters = [];

      this.group.reporters = reporters;
    },
    getGroup() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group/${this.id}`)
        .then((response) => {
          this.group = response.data;
          this.getUsers();
        });
    },
    getUsers() {
      this.$http
        .get(`${process.env.VUE_APP_BASE_URI}/group/users/${this.id}`)
        .then((response) => {
          this.users = response.data;
        });
    },
    checkForm() {
      if (!this.group.name) {
        this.isNameValid = false;
      }

      if (this.isNameValid) {
        return true;
      }
      // if not
      return false;
    },
    create() {
      if (this.checkForm()) {
        this.$http
          .post(`${process.env.VUE_APP_BASE_URI}/group`, this.group)
          .then(() => {
            this.$snotify.success(
              "Успешно създадена бригада. Може да я добавите в профилите на работниците."
            );
            // this.newLog('newUser', this.user.username);
            this.closeModal(true);
          })
          .catch((error) => {
            console.log(error.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    edit() {
      if (this.checkForm()) {
        this.$http
          .put(`${process.env.VUE_APP_BASE_URI}/group`, this.group)
          .then(() => {
            this.$snotify.success("Промените са записани успешно!");

            // this.newLog('editUser', this.user.username);
            this.closeModal(true);
          })
          .catch((error) => {
            console.log(error.response);
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
          })
          .then(() => {});
      } else {
        // TODO: Do something
      }
    },
    closeModal(update) {
      this.$emit("close", update);
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        if (this.id) {
          this.edit();
        } else {
          this.create();
        }
      } else if (e.code === "Escape") {
        this.closeModal(false);
      }
    },
  },
  mounted() {
    if (this.id) {
      this.getGroup();
    }

    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.group-modal-wrapper {
  align-items: center;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}
.group-modal {
  background-color: #fff;
  border-radius: 4px;
  /* border-top: 10px solid #6d2600; */
  display: flex;
  flex-direction: column;
  /* height: 60vh; */
  overflow: auto;
  padding: 10px 20px 0;
  width: 800px;
  -webkit-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  -moz-box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
  box-shadow: 10px 10px 204px -19px rgba(0, 0, 0, 0.52);
}
.group-modal-permissions {
  background-color: #f4f4f4;
  border-radius: 4px;
  display: flex;
  justify-content: center;
}
.group-modal-actions {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
}
.invalid .mck {
  color: #d91313;
}
.invalid input {
  background-color: #f8dcdc;
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}
.invalid input::placeholder {
  color: #d91313;
}

/* Responsive */
@media screen and (max-width: 900px) {
  .group-modal {
    width: 90%;
  }
}
@media screen and (max-width: 500px) {
  .group-modal-actions {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .switch-container {
    display: flex;
    justify-content: center;
    margin-bottom: 1em;
  }
  .btns {
    justify-content: center;
  }
  .group-modal-permissions {
    flex-direction: column;
  }
}
@media screen and (max-height: 550px) {
  .group-modal {
    height: 100%;
  }
}
</style>
